import React from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import i18n from '~~locales/i18n';
import { store } from '~~stores/store';
import Routes from '~~routes/Routes';
import '~~utils/yup-extended';
import './app.less';
import enUS from 'antd/es/locale/en_US';
import zhTW from 'antd/es/locale/zh_TW';
import jaJP from 'antd/es/locale/ja_JP';

message.config({
  top: 100,
  duration: 3,
  maxCount: 1,
});

const ANTD_LOCALE = {
  'en-US': enUS,
  'zh-TW': zhTW,
  'ja-JP': jaJP,
} as const;

const AntdConfig: React.FC<React.PropsWithChildren> = (props) => {
  const { children } = props;
  const { i18n: { language } } = useTranslation();
  return (
    <ConfigProvider locale={ANTD_LOCALE[language as keyof typeof ANTD_LOCALE] || enUS}>
      {children}
    </ConfigProvider>
  );
};

const App = () => (
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <AntdConfig>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AntdConfig>
    </I18nextProvider>
  </Provider>
);
export default App;
